import { noop } from 'lodash';
import { ViewIds } from '@ardoq/api-types';
import { dispatchAction } from '@ardoq/rxbeach';
import {
  updateViewContext,
  updateViewProperties as updateViewPropertiesAction,
  updateViewSettings as updateViewSettingsAction,
} from '@ardoq/view-settings';
import { updateViewEmptyStateData as updateViewEmptyStateDataAction } from 'appLayout/ardoqStudio/emptyState/actions';
import { relationshipDiagramReset } from 'tabview/relationshipDiagrams/actions';
import { recordRenderComplete } from 'tracking/durationTracking/viewPerformance';
import { EMPTY_GRAPH_EVENT_HANDLERS } from 'tabview/relationshipDiagrams/consts';
import { getDefaultGraphEventHandlers } from 'tabview/graphComponent/graphEvents';
import { defaultLegendOnClick } from 'viewSettings/getRightMenuConfig';
import { defaultHandleImageDropCallback } from 'yfilesExtensions/view/highlightIndicator/modernized/ModernizedHighlightIndicatorManager';
import type {
  ModernizedBlockDiagramBaseCommands,
  ModernizedBlockDiagramCommands,
  ModernizedBlockDiagramDataLayerCommands,
} from './types';

const VIEW_ID = ViewIds.MODERNIZED_BLOCK_DIAGRAM;

export const DEFAULT_MODERNIZED_BLOCK_DIAGRAM_COMMANDS: ModernizedBlockDiagramBaseCommands =
  {
    resetLayout: () => dispatchAction(relationshipDiagramReset()),
    updateViewContext: viewContext =>
      dispatchAction(updateViewContext(viewContext)),
    updateViewProperties: viewProperties =>
      dispatchAction(
        updateViewPropertiesAction({ viewId: VIEW_ID, viewProperties })
      ),
    updateViewEmptyStateData: isViewEmpty =>
      dispatchAction(
        updateViewEmptyStateDataAction({
          viewEmptyStateData: { isViewEmpty },
          viewId: VIEW_ID,
        })
      ),
    updateViewSettings: settings =>
      dispatchAction(
        updateViewSettingsAction({
          viewId: VIEW_ID,
          settings,
          persistent: true,
        })
      ),
    toggleLegend: isLegendActive =>
      defaultLegendOnClick({ isLegendActive, viewId: VIEW_ID }),
    handleImageDrop: defaultHandleImageDropCallback,
    recordRenderComplete,
  };

export const NOOP_MODERNIZED_BLOCK_DIAGRAM_COMMANDS: ModernizedBlockDiagramDataLayerCommands =
  {
    updateViewContext: noop,
    updateViewProperties: noop,
    updateViewEmptyStateData: noop,
    updateViewSettings: noop,
    toggleLegend: noop,
    handleImageDrop: noop,
    recordRenderComplete: noop,
    recordViewModelReady: noop,
    graphEventHandlers: EMPTY_GRAPH_EVENT_HANDLERS,
  };

export const createModernizedBlockDiagramCommands = (
  viewInstanceId: string
): ModernizedBlockDiagramCommands => ({
  ...DEFAULT_MODERNIZED_BLOCK_DIAGRAM_COMMANDS,
  graphEventHandlers: getDefaultGraphEventHandlers({
    viewId: VIEW_ID,
    viewInstanceId,
    isViewpointMode: () => true,
  }),
});
